<template>
  <div class="phone-input">
    <div class="input left flex-row align-items-center has-background-white">
      <span :class="{'flag': isChrome, 'flag-default': !isChrome}">{{ countryStore.flag }}</span>
    </div>
    <span class="input">+{{ countryStore.phoneCountryCode }}</span>
    <InputMask
      class="input right"
      type="tel"
      v-model="phone"
      @update:modelValue="onInput"
      :mask="countryStore.phoneMask"
      slotChar="_"
      @keydown.enter="emitSend"
    />
  </div>
</template>

<script setup>
import { useCountryStore } from "~~/stores/country";

const countryStore = useCountryStore();

const props = defineProps(["modelValue"]);
const emit = defineEmits(["update:modelValue", "send"]);

const phone = ref(null);

const isChrome = /Chrome/.test(navigator.userAgent);

function emitSend(event) {
  emit("send", event);
}

onBeforeMount(() => {
  phone.value = props.modelValue.replaceAll(/\D/g, "").slice(countryStore.phoneCountryCode.length);
});

const onInput = () => {
  emit("update:modelValue", countryStore.phoneCountryCode + phone.value.replaceAll(/\D/g, ""));
};
</script>

<style scoped lang="scss">
.phone-input {
  display: flex;
  flex-direction: row;

  .input {
    padding: 14px 0.25em 14px 8px;
    border: none;
    border-top: 1px solid var(--gray400);
    border-bottom: 1px solid var(--gray400);
    line-height: 25px;

    &.left {
      position: relative;
      border-radius: 8px 0 0 8px;
      border-left: 1px solid var(--gray400);
      padding: 14px 8px 14px 8px;
      font-size: 8px;

      &::after {
        content: "";
        position: absolute;
        right: 0;
        width: 1px;
        height: 32px;
        background: var(--gray400);
      }
    }

    &.right {
      border-radius: 0 8px 8px 0;
      border-right: 1px solid var(--gray400);
      padding: 14px 14px 14px 0;
      flex: 1;
    }
  }
}
</style>

<style lang="scss">
.phone-input .input.left {
  align-items: center;
}
</style>
